export default {
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12.25px 1.3rem',
    // border: '1px solid #F2F7FF',
    alignItems: 'center'
  }
};
